<template>
  <section class="rating">

    <header>
      <time
        v-if="showTime"
        :datetime="date.toISOString()"
      >{{ date | formatDateTime }} Uhr</time>
      <time
        v-else
        :datetime="date.toISOString()"
      >{{ date | formatDate }}</time>
    </header>

    <p class="rating__rating">
      <span class="sr-only">
        Bewertung: <strong>{{ rating }} {{ rating === 1 ? 'Stern' : 'Sterne' }}</strong>
      </span>
      <span
        v-for="n in 5"
        :class="{ 'is-highlighted': n <= rating }"
        :key="n"
        class="rating__star"
      />
    </p>

    <div v-if="comment">
      <p
        v-for="(paragraph, index) in comment.split(/\n\s*\n/g)"
        :key="index"
      >
        {{ paragraph }}
      </p>
    </div>

  </section>
</template>

<script>
import formatDate from '@/functions/formatDate'
import formatDateTime from '@/functions/formatDateTime'

export default {
  name: 'CRating',

  filters: {
    formatDate,
    formatDateTime
  },

  props: {
    comment: {
      type: String
    },
    date: {
      type: Date,
      required: true
    },
    rating: {
      type: Number,
      required: true,
      validator (value) {
        return value >= 0 && value <= 5
      }
    },
    showTime: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
.rating > :last-child {
  margin-bottom: 0;
}

.rating__rating {
  display: flex;
}

.rating__star {
  display: block;
  width: 26px;
  height: 26px;
  margin-right: 4px;

  background: url("~@/assets/form-star-empty.svg") center / 26px no-repeat;
}

.rating__star.is-highlighted {
  background-image: url("~@/assets/form-star-full.svg");
}
</style>
